import { ModuleWithProviders, NgModule, inject } from '@angular/core';
import { AuthGuard } from './guards/auth.guard';
import { NoAuthGuard } from './guards/no-auth.guard';
import { AuthModuleConfig } from './auth.module.config';
import { AUTHENTICATE_OPTIONS } from './auth.providers';

@NgModule()
export class AuthModule {
  constructor() {
    const module = inject(AuthModule, { optional: true, skipSelf: true });

    if (module) {
      throw new Error(`${AuthModule.name} should be imported only once!`);
    }
  }

  static forRoot(config: AuthModuleConfig): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        AuthGuard,
        NoAuthGuard,
        {
          provide: AUTHENTICATE_OPTIONS,
          useValue: config.authenticateOptions,
        },
      ],
    };
  }
}
